import { useEffect, useState } from 'react';
import { getMarketSession } from '@/lib/market-hours';
import { StatusDot } from '@/components/ui';
import type { Tone } from '@/components/ui';

const TONE: Record<string, Tone> = {
  open: 'success',
  'pre-open': 'warning',
  closed: 'neutral',
  weekend: 'neutral',
};

/**
 * Real NSE/BSE session state from the clock. Not a live feed indicator — the
 * market feed's own status is shown on the Market Watch screen.
 */
export function MarketStatus({ className }: { className?: string }) {
  const [session, setSession] = useState(() => getMarketSession());

  useEffect(() => {
    const id = setInterval(() => setSession(getMarketSession()), 30_000);
    return () => clearInterval(id);
  }, []);

  return (
    <span className={className}>
      <span className="inline-flex items-center gap-1.5">
        <StatusDot tone={TONE[session.state]} />
        <span className="text-xs text-fg-muted">{session.label}</span>
      </span>
    </span>
  );
}
